import { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, Transition, Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import CommonButton from "../../common/CommonButton";
import ModalCloseButton from "../../common/ModalCloseButton";
import AppContext from "../../../context/AppContext";
import { getAllAgentList, getAllGeoCode, getAllSpecialAssign, getUpdateSpecialAssign } from "../../../service/Configuration";
import ReactSelector from "../../common/CommonReactSelector";
import { components } from 'react-select';
import translations from "../../common/Translations";
const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};

export default function ChangeRuleModal({ open, setOpen, selectedItem, setSpecialAssign }) {

  const [GeoCodes, setGeoCodes] = useState([])
  const [rule_list, setRuleList] = useState({
    id: selectedItem?.id,
    assigneeIds: [],
    areaCodes: [],
    active: "true",
  })

  const { activityId, projectId, langMode } = useContext(AppContext);
  const organizationId = JSON.parse(localStorage.getItem("selectedOrgId"))

  const handleGeoCode = (selectedGeo) => {
    const value = selectedGeo?.map((geo) => geo.value)
    setRuleList({
      ...rule_list,
      areaCodes: value
    })
  }
  const handleUpdateRule = async () => {

    const result = await getAllAgentList(organizationId)

    const matchingUserIds = selectedItem.userNames.map(name => {
      const user = result.find(u => u.name === name);
      return user ? user.userId : null;
    }).filter(id => id !== null);

    const payload = {
      rule: {
        ...rule_list,
        userId: matchingUserIds,
        projectId,
      },
      assign: false
    }

    const results = await getUpdateSpecialAssign({ payload })
    if (results === "Updated Successfully") {
      const data = await getAllSpecialAssign(projectId, 0, 10)
      setSpecialAssign(data?.ruleList)
    }
    setOpen(false)
  }
  useEffect(() => {
    const fetchGeoCode = async () => {
      try {
        const result = await getAllGeoCode(projectId)
        setGeoCodes(result)
      } catch (error) {
        console.error('Error fetching geo code:', error);
      }
    }

    fetchGeoCode()
  }, [projectId])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95">
            <Dialog.Panel className="flex max-h-[calc(100dvh-1rem)] w-full max-w-4xl transform flex-col gap-4 overflow-y-auto overflow-x-hidden rounded-lg bg-white p-3 shadow-xl sm:gap-[27px] sm:p-6">
              <Dialog.Title className="flex min-w-0 justify-between gap-3 text-left text-base font-bold text-[#000000]">
                Rule for Rajah Al
                <ModalCloseButton onClick={() => setOpen(false)} />
              </Dialog.Title>
              {/* Same label + full-width control shape as the Geo Codes field in
                  NewRuleModal.js/UpdateRuleModal.js (which in turn matches
                  AssigneePicker's "Assign To" selector). */}
              <div className="flex flex-col gap-1.5 w-full">
                <label className="block text-sm font-semibold text-gray-900 dark:text-white">
                  {translations[langMode].geoCodes}
                </label>
                <ReactSelector
                  options={
                    (GeoCodes || [])?.filter(Boolean)?.map((item) => ({
                      value: item,
                      label: item,
                    }))}
                  onChange={handleGeoCode}
                  components={{ Placeholder }}
                  placeholder={'Select Geo Code'}
                  isClearable={false}
                  isMulti
                  height="46px"
                  selectedValuesMaxHeight="64px"
                  menuPortalTarget={document.body}
                  overflow="overlay"
                />
              </div>
              <div className="flex justify-end items-center gap-3">
                <CommonButton colorIntent="danger"
                  onClick={() => setOpen(false)}
                  variant="danger"
                >
                  {translations[langMode].cancle}
                </CommonButton>
                <CommonButton colorIntent="success"
                  onClick={handleUpdateRule}
                  variant="primary" >
                  {translations[langMode].ok}
                </CommonButton>

              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
